// src/pages/About/scenes/Scene.jsx
import { useEffect } from "react";
import { useOutletContext, useParams } from "react-router-dom";
import SceneShell from "./SceneShell";
import i18n from "@/i18n";

export default function Scene() {
  const { id } = useParams();
  const { script, markSeen } = useOutletContext();

  const chapter = script?.chapters?.[id];

  useEffect(() => {
    if (id) markSeen(id);
  }, [id]); // eslint-disable-line

  if (!script) return null;
  if (!chapter) return <p style={{ padding: 16 }}>{i18n.t("about.mChapter")} : {id}</p>;

  return <SceneShell id={id} chapter={chapter} />;
}
